import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @param cancelToken - Token to cancel multiple requests
 * @returns - Array of Terminal List of type string[]
 */

export const exceptionAssign = async (params: any) => {
  try {
    const response = await axios.post(getUrl(ApiType.EXCEPTION_ASSIGN), params);
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.exceptionAssign, { badRequestOrder: "errorsFirst" });
  }
};
